"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FB_APP_ID = exports.BING_WEBMASTER_VERIFICATION = exports.YAHOO_KEY = exports.EB_DEFAULT_ORANGE_HEX = exports.MS_APP_TILE_IMG_PATH = exports.OPEN_GRAPH_DEFAULT_IMAGE_HEIGHT = exports.OPEN_GRAPH_DEFAULT_IMAGE_WIDTH = exports.OPEN_GRAPH_DEFAULT_IMAGE_PATH = void 0;
exports.OPEN_GRAPH_DEFAULT_IMAGE_PATH = "https://cdn.evbstatic.com/s3-build/perm_001/6ce389/django/images/logos/eb_orange_on_white_1200x630.png";
exports.OPEN_GRAPH_DEFAULT_IMAGE_WIDTH = "1200";
exports.OPEN_GRAPH_DEFAULT_IMAGE_HEIGHT = "630";
exports.MS_APP_TILE_IMG_PATH = "https://cdn.evbstatic.com/s3-build/perm_001/8ad267/django/images/favicons/mstile-144x144.png";
exports.EB_DEFAULT_ORANGE_HEX = "#f6682f";
exports.YAHOO_KEY = "d92e23811007b438";
exports.BING_WEBMASTER_VERIFICATION = "A9AB07B7E430E4608E0BC57AFA5004AA";
exports.FB_APP_ID = "28218816837";
//# sourceMappingURL=constants.js.map